var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"display-5"},[_vm._v(_vm._s(this.title))]),_c('Statistics',{attrs:{"statsData":_vm.statsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }